import React from "react";
import { useTranslation } from "./hooks/useTranslation";
import { Button } from "./Button";
var Bookend = function (_a) {
    var title = _a.title;
    return (React.createElement("div", { className: "bookend" },
        React.createElement("span", { className: "bookend-circle" }),
        React.createElement("span", { className: "bookend-title" }, title)));
};
export var LearningPath = function (_a) {
    var children = _a.children;
    var t = useTranslation();
    return (React.createElement("div", { className: "LearningPath" },
        React.createElement(Bookend, { title: t("Start") }),
        React.createElement("ul", { className: "learning-path-ul" }, children),
        React.createElement(Bookend, { title: t("End") })));
};
export var LearningPathActions = function (_a) {
    var children = _a.children;
    return (React.createElement("li", { className: "learning-path-li learning-path--actions" },
        React.createElement("div", null, children)));
};
export var LearningPathPagination = function (_a) {
    var totalNextPageRecords = _a.totalNextPageRecords, onClick = _a.onClick, disabled = _a.disabled, id = _a.id;
    return (React.createElement("li", { className: "learning-path--pagination" },
        React.createElement("span", { className: "glyphicon-pro glyphicon-pro-squares" }),
        React.createElement(Button, { label: "Show more".concat(totalNextPageRecords ? " (".concat(totalNextPageRecords, ")") : ""), onClick: onClick, type: "default", disabled: disabled, id: id })));
};
